import React from "react";
import { useNavigate } from "react-router-dom";
import { RAPID_FIRE_ROUTES } from "./rapidFireRoutes";
import "./RapidAttemptCard.css";
import "../quizzes/QuizAttemptsCard.css";

const Attempts = ({ attempts = [], navigationState = {} }) => {
  const navigate = useNavigate();

  return (
    <section className="attempteds-section rapid-attempt">
      <div className="attempteds-heading mt-3">
        <h3>Attempts</h3>
      </div>

      <div className="">
        <div className="">
          <div className="attempteds-grid">
            {attempts.map((attempted) => {
              const progress = Math.min(Math.max(attempted.progress || 0, 0), 100);

              return (
                <div className="attempted-card rapidattempted-card" key={attempted.batchId || attempted.id}>
                  <div className="attempted-top">
                    <div className={`attempted-number ${attempted.color}`}>
                      {attempted.id}

                      <span className="attempted-check">
                        <i className="fa-solid fa-fire"></i>
                      </span>
                    </div>

                    <div className="attempted-details">
                      <h4>{attempted.title}</h4>

                      <p className="attempted-date">
                        <i className="bi bi-clock"></i>

                        <span>{attempted.date}</span>
                      </p>
                    </div>

                    <button
                      type="button"
                      className="attempted-review-btn"
                      onClick={() =>
                        navigate(RAPID_FIRE_ROUTES.answerSheet, {
                          state: {
                            ...navigationState,
                            selectedBatch: attempted,
                          },
                        })
                      }
                    >
                      Review
                    </button>
                  </div>

                  <div className="attempted-progress">
                    <div className="attempted-progress-bar">
                      <span
                        className="attempted-progress-fill"
                        style={{
                          width: `${progress}%`,
                        }}
                      />
                    </div>

                    <span className="attempted-progress-percent">{progress}%</span>
                  </div>

                  <div className="attempted-bottom">
                    <div className="attempted-bottom-stat">
                      <i className="bi bi-lightning-charge-fill"></i>

                      <span>
                        <strong>{attempted.attempts}</strong>{" "}
                        Attempts
                      </span>
                    </div>

                    <div className="attempted-bottom-stat">
                      <i className="bi bi-file-earmark-text"></i>

                      <span className="d-flex gap-1">
                        <strong>{attempted.questions}</strong>{" "}
                        Questions
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Attempts;
